import PropTypes from "prop-types"
import React from "react"
import dockwaPlusCardImage from "src/assets/dockwa-plus/dockwa-plus-card.png"

class DockwaPlusCard extends React.Component {
  render() {
    return (
      <img
        className={this.props.className}
        alt="Dockwa+ Membership Card"
        src={dockwaPlusCardImage}
      />
    )
  }
}

DockwaPlusCard.propTypes = {
  className: PropTypes.string,
}

export default DockwaPlusCard
